import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  assetDataService,
  assetSharedModelService,
} from 'app/services';
import {
  confirmDialog,
  alerts,
  actionIcon
} from 'app/components/global';
import controller from './sync-asset.controller';
import directive from './sync-asset.directive';


const syncAssetModule = angular.module('app.components.admin.syncAsset', [
  alerts,
  actionIcon,
  confirmDialog,
  loaderService,
  ssDialogService,
  assetDataService,
  assetSharedModelService,
])
  .directive('syncAsset', directive)
  .controller('SyncAssetController', controller);

export default syncAssetModule.name;

console.log('app.components.admin.syncAsset created');
